var _path, _mask, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA6A6",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.5 7.676 12 2l8.5 5.676V19.2a.8.8 0 0 1-.8.8H4.3a.8.8 0 0 1-.8-.8z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "home_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 12a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v8H8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA6A6",
    d: "M6.5 12A2.5 2.5 0 0 1 9 9.5h6a2.5 2.5 0 0 1 2.5 2.5l-3 .5h-5zm9.5 8H8zm-9.5 0v-8A2.5 2.5 0 0 1 9 9.5l.5 3V20zM15 9.5a2.5 2.5 0 0 1 2.5 2.5v8h-3v-7.5z",
    mask: "url(#home_svg__a)"
  })));
};
export default SvgHome;